export default {"src":"/_next/static/media/logo.547fc088.svg","height":60,"width":180,"blurWidth":0,"blurHeight":0};